import React from "react";
import WidgetSelector from "./WidgetSelector";

export default function WidgetDesignationSelector({
  value,
  displayValue,
  designations,
  onChange,
  reloadDropdownData,
  viewOnly,
  size,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={designations}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Designation"
        showCloudIcon={true}
        size={size}
      />
    </React.Fragment>
  );
}
